module.exports = __webpack_public_path__ + "img/monitorbox16.3a5ecc3e.jpg";